export type VoiceContextPolicyKind =
  | 'operator_request' | 'agent_message' | 'background_work'
  | 'focus_boundary' | 'ambient_boundary' | 'ambient_message'
  | 'app_event' | 'summary' | 'agent_voice_response';

/** Arcturian is operator-driven unless the future, explicit "inform me"
 * contract is active. Bulk live-feed items would otherwise stay in the
 * Realtime conversation and be billed again as input on every later turn even
 * though the mode never narrates them. Keep only the minimal focus pointer and
 * explicit action returns that already have a visible/audible consumer. */
export function shouldInjectVoiceContext(
  companionMode: string,
  kind: VoiceContextPolicyKind,
  arcturianInforming = false,
): boolean {
  if (companionMode !== 'arcturian' || arcturianInforming) return true;
  return kind === 'focus_boundary' || kind === 'agent_voice_response';
}
